<template>
    <app-main>
        <app-content>

             <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Tyres"
                        sub-title="Control tyre landing page"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="boxes" :handle-click="toggle" :active="active">Boxes</app-tabs-trigger>
                    <app-tabs-trigger name="menu" :handle-click="toggle" :active="active">Menu &amp; iFrame</app-tabs-trigger>
                    <app-tabs-trigger name="tyre-brands" :handle-click="toggle" :active="active">Tyre brands</app-tabs-trigger>
                </div>
                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-select
                            :required="true"
                            label="Locale"
                            :items="items.locales"
                            v-model="fields.locale_id"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.locale_id"
                        />

                        <app-field-toggle
                            :required="false"
                            label="Published?"
                            v-model="fields.published"
                            :error="errors.published"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Published At"
                            v-if="fields.published"
                            v-model="fields.published_at"
                            :error="errors.published_at"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="boxes" :active="active">
                        <div v-for="box in fields.boxes">
                            <div class="flex flex-wrap -mx-2">
                                <div class="w-full px-2">
                                    <app-field-text
                                        label="Title"
                                        v-model="box.title"
                                        :error="errors.title"
                                    />
                                </div>
                            </div>

                            <div class="flex flex-wrap -mx-2">
                                <div class="w-full md:w-1/3 px-2">
                                    <app-field-text
                                        label="Price Copy"
                                        v-model="box.from_copy"
                                        :error="errors.from_copy"
                                    />
                                </div>
                                <div class="w-full md:w-1/3 px-2">
                                    <app-field-text
                                        label="Price Copy Suffix"
                                        v-model="box.from_copy_suffix"
                                        :error="errors.from_copy_suffix"
                                    />
                                </div>
                                <div class="w-full md:w-1/3 px-2">
                                    <app-field-currency
                                        :required="true"
                                        :classes="{ wrapper: { 'reset': true } }"
                                        label="Default Price"
                                        v-model="box.price"
                                        :error="errors.price"
                                    />
                                </div>
                            </div>

                            <app-field-text
                                label="Image URL"
                                v-model="box.image_url"
                                :error="errors.image_url"
                            />

                            <div class="flex flex-wrap -mx-2">
                               <div class="w-full md:w-1/2 px-2">
                                   <app-field-file
                                       :required="false"
                                       label="Image"
                                       v-model="box.image"
                                       helper=""
                                       :types="{images: true, files: false}"
                                   />
                               </div>
                           </div>

                           <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>
                       </div>

                       <app-button element="a" class="btn  btn--tertiary  btn--tertiary--sml" v-if="fields.boxes.length < 3" @click="add('box')">
                           Add Box (max 3)
                       </app-button>
                    </app-tabs-content>
                    <app-tabs-content name="menu" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Title"
                                    v-model="fields.iframes.title"
                                    :error="errors.title"
                                />
                            </div>
                        </div>

                        <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>

                        <div v-for="menu in fields.iframes.items">
                            <div class="flex flex-wrap -mx-2">
                                <div class="w-full md:w-1/2 px-2">
                                    <app-field-text
                                        label="Title"
                                        v-model="menu.title"
                                        :error="errors.title"
                                        @input="updateSlug( index )"
                                    />
                                </div>
                                <div class="w-full md:w-1/2 px-2">
                                    <app-field-text
                                        label="Slug"
                                        v-model="menu.slug"
                                        :error="errors.slug"
                                    />
                                </div>
                            </div>

                            <div class="flex flex-wrap -mx-2">
                                <div class="w-full px-2">
                                    <app-field-text
                                        label="iFrame URL"
                                        v-model="menu.iframe"
                                        :error="errors.iframe"
                                    />
                                </div>
                            </div>

                           <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>
                       </div>

                       <app-button element="a" class="btn  btn--tertiary  btn--tertiary--sml" v-if="fields.iframes.items.length < 4" @click="add('iframe')">
                           Add menu item
                       </app-button>
                    </app-tabs-content>
                    <app-tabs-content name="tyre-brands" :active="active">
                        <div v-for="brand in fields.tyre_brands">
                            <div class="flex flex-wrap -mx-2">
                                <div class="w-full px-2">
                                    <app-field-text
                                        label="Brand URL"
                                        v-model="brand.url"
                                        :error="errors.url"
                                    />
                                </div>
                            </div>

                            <div class="flex flex-wrap -mx-2">
                               <div class="w-full md:w-1/2 px-2">
                                   <app-field-file
                                       :required="false"
                                       label="Tyre brand logo"
                                       v-model="brand.image"
                                       helper=""
                                       :types="{images: true, files: false}"
                                   />
                               </div>
                            </div>

                           <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>
                       </div>

                       <app-button element="a" class="btn  btn--tertiary  btn--tertiary--sml" @click="add('brand')">
                           Add tyre brand
                       </app-button>
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CodeField from '@/components/fields/inputs/Code';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';

    /* Builder components */
    import Builder from '@/components/composer/Builder';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'tyres.edit',

        data: () => ({
            loading: true,
            settings: null,
            pages: [],
            fields: {
                boxes: [
                    {
                        title: '',
                        from_copy: '',
                        from_copy_suffix: '',
                        price: '',
                        image_url: '',
                        image: '',
                    },
                ],
                iframes: {
                    title: '',
                    items: [
                        {
                            title: '',
                            slug: '',
                            iframe: '',
                        },
                    ],
                },
                tyre_brands: [
                    {
                        url: '',
                        image: '',
                        alt: '',
                    },
                ],
            },
            items: {
                locales: []
            },
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-builder': Builder,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-code': CodeField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-currency': CurrencyField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            this.loading = true;

            this.getLocations()
                .then(response => {
                    if (typeof this.$route.params.id != 'undefined') {
                        this.getTyre(this.$route.params.id)
                            .then(response => {
                                this.setLocales();

                                for (let index in this.parent) {
                                    if (typeof this.fields[index] !== 'undefined') {
                                        switch (index) {
                                            case "published_at":
                                                if(this.parent[index] != null) {
                                                    this.fields[index] = this.parent[index].split(' ').join('T') + '.000Z';
                                                }
                                                break;

                                            default:
                                                this.fields[index] = this.parent[index];
                                        }
                                    }
                                }

                                this.fields.parent_id = this.$route.params.id;
                            });
                    } else {
                        this.setLocales();
                    }
                })
                .then(response => {
                    this.loading = false;
                });
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        methods: {
            updateSlug( index ) {
                this.fields.iframes.items[index].slug = this.fields.iframes.items[index].title.toString().toLowerCase()
                    .replace(/\s+/g, '-')           // Replace spaces with -
                    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                    .replace(/^-+/, '')             // Trim - from start of text
                    .replace(/-+$/, '');            // Trim - from end of text
            },
            getLocations() {
                return Api.request('get', `tyres/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                    });
            },
            getTyre(id) {
                return Api.request('get', `tyres/edit/${id}`)
                    .then(({ data }) => {
                        this.parent = data.article;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', 'tyres/create', this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'tyres.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        if (!this.parent || (typeof this.parent.locale != 'undefined' && typeof this.parent.locale.flag != 'undefined' && this.parent.locale.flag != locale.flag)) {
                            this.items.locales.push({
                                label: locale.lang,
                                value: locale.id
                            });
                        }
                    });
                }
            },
            add(type) {
                if (type == 'box') {
                    this.fields.boxes.push({
                        title: '',
                        from_copy: '',
                        from_copy_suffix: '',
                        price: '',
                        image_url: '',
                        image: '',
                    });
                } else if (type == 'iframe') {
                    this.fields.iframes.items.push({
                        title: '',
                        iframe: '',
                    });
                } else if (type == 'brand') {
                    this.fields.tyre_brands.push({
                        url: '',
                        image: '',
                        alt: '',
                    });
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/tyres/New.vue